// localStorage utility functions
// Simplified version based on watson-director's app-module-storage.ts

/**
 * Store a JSON object in localStorage
 */
export function storeLocalJSON(key: string, value: any): void {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (error) {
    console.error(`Failed to store ${key} in localStorage:`, error)
    throw error
  }
}

/**
 * Get a JSON object from localStorage with type safety
 */
export function getLocalJSON<T>(key: string): T | null {
  try {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) : null
  } catch (error) {
    console.error(`Failed to get ${key} from localStorage:`, error)
    return null
  }
}

/**
 * Check if a key exists in localStorage
 */
export function hasLocal(key: string): boolean {
  try {
    return localStorage.getItem(key) !== null
  } catch (error) {
    console.error(`Failed to check ${key} in localStorage:`, error)
    return false
  }
}

/**
 * Delete a key from localStorage
 */
export function deleteLocal(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error(`Failed to delete ${key} from localStorage:`, error)
  }
}






